// extracted by mini-css-extract-plugin
module.exports = {"root":"_8J0xwoH4"};